import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/topUpAddOns/topUpCardStyle';
import { makeStyles } from '@material-ui/styles';
import Button from 'components/CustomButtons/Button';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleTopUpValueProps {
	checked: boolean;
	value: number;
	setTopUpValue?: React.Dispatch<React.SetStateAction<number>>;
}

const SingleTopUpValue = ({ checked, value, setTopUpValue }: ISingleTopUpValueProps) => {
	const classes = useStyles();

	return (
		<div className={classes.singleTopupValueWrapper}>
			<Button color={checked ? 'primary-light' : 'tertiary-light'} onClick={() => setTopUpValue?.(value)}>
				{String(value)}
			</Button>
		</div>
	);
};

export default SingleTopUpValue;
